import React from 'react';

/**
 * Shown in place of a chart when chartVisible is true but there's nothing
 * to plot — otherwise the chart area would just go blank with no
 * indication of why.
 */
export const ChartEmptyState: React.FC = () => (
  <div className="flex items-center justify-center py-6 text-center">
    <span className="text-sm text-gray-muted">No data to display</span>
  </div>
);
